export const ESTIMATION_FIELD_ID_ORIGINAL_ESTIMATE = 'timeoriginalestimate' as const;
